// 261015 P3b — quyết định hiển thị chốt dàn tập; thuần để Jest CRA không phải nạp antd.
import { friendlyApiError } from './jobErrorText';
import { overviewErrorView, type ErrorExit } from './overview/overviewErrors';

export type EpisodePlanState = 'PENDING' | 'APPROVED' | 'STALE';
export interface EpisodePlanView { state: EpisodePlanState; reason?: 'EPISODES_STALE' | 'PLAN_CHANGED' | 'SOURCE_SLICE_CHANGED' | 'SOURCE_SLICE_MISSING'; approvedByName?: string; approvedAt?: string }

export const episodePlanCopy = (plan: EpisodePlanView | null | undefined): { tone: 'info' | 'success' | 'warning'; text: string; action: 'approve' | 'reapprove' | 'unapprove' | 'resplit' } => {
  if (plan?.state === 'APPROVED') return { tone: 'success', text: `Đã chốt dàn tập${plan.approvedByName ? ` bởi ${plan.approvedByName}` : ''}.`, action: 'unapprove' };
  if (plan?.state === 'STALE') {
    if (plan.reason === 'EPISODES_STALE') return { tone: 'warning', text: 'Danh sách tập đã cũ — cần chia lại tập trước khi chốt.', action: 'resplit' };
    if (plan.reason === 'SOURCE_SLICE_MISSING') return { tone: 'warning', text: 'Không còn đủ nội dung nguồn của dàn tập — cần chia lại tập trước khi chốt.', action: 'resplit' };
    if (plan.reason === 'SOURCE_SLICE_CHANGED') return { tone: 'warning', text: 'Nội dung nguồn của lát dàn tập đã đổi — xem lại rồi chốt lại.', action: 'reapprove' };
    return { tone: 'warning', text: 'Dàn tập đã sửa sau khi chốt — xem lại rồi chốt lại.', action: 'reapprove' };
  }
  return { tone: 'info', text: 'Chốt dàn tập trước khi tạo kịch bản mới.', action: 'approve' };
};

/** Phần của `adaptationApi` mà lệnh chốt dàn tập dùng (tách để test không nạp axios/antd). */
export interface EpisodePlanApprovalApi {
  approveEpisodePlan: (storyId: string, expectedModifiedAt: string) => Promise<unknown>;
  appendRunContinue: (storyId: string, expectedModifiedAt?: string) => Promise<unknown>;
}

/**
 * 261015 P4c-1 (review FE #1): MỘT lệnh chốt dàn tập cho cả hai đường — đều mang `modifiedAt` của bản người đang xem (BE đòi cả hai).
 * Đang chờ STOP 2 của "Xử lý phần mới" ⇒ `append-run/continue` (BE chốt nguyên tử rồi mở writer); ngược lại ⇒ chốt thường.
 */
export const submitEpisodePlanApproval = (api: EpisodePlanApprovalApi, a: { storyId: string; modifiedAt: string; appendWaiting: boolean }): Promise<unknown> =>
  a.appendWaiting ? api.appendRunContinue(a.storyId, a.modifiedAt) : api.approveEpisodePlan(a.storyId, a.modifiedAt);

/**
 * Chữ + mức cho lỗi khi chốt/bỏ chốt dàn tập (caller luôn tải lại sau lỗi để người xem bản mới).
 * 261015 P4c-2b (D9b): `OVERVIEW_NOT_EFFECTIVE` (409) ⇒ `exit:'openOverview'` + `extra` (nguyên nhân từng dòng) để caller dựng lối ra "Mở Tổng quan truyện".
 */
export const episodePlanSaveErrorView = (e: unknown, fallback: string): { level: 'warning' | 'error'; text: string; exit?: ErrorExit; extra?: string[] } => {
  const code = (e as { response?: { data?: { code?: unknown } } } | null | undefined)?.response?.data?.code;
  if (code === 'OVERVIEW_NOT_EFFECTIVE') { const v = overviewErrorView(e, fallback); return { level: 'warning', text: v.text, exit: v.exit, extra: v.extra }; }
  if (code === 'OUTLINE_CHANGED') return { level: 'warning', text: 'Danh sách tập vừa đổi ở nơi khác — đã tải lại, xem bản mới rồi chốt lại' };
  if (code === 'EXPECTED_MODIFIED_AT_REQUIRED' || code === 'INVALID_EXPECTED_MODIFIED_AT') return { level: 'warning', text: 'Chưa có mốc của dàn tập đang xem — đã tải lại, thử lại' };
  return { level: 'error', text: friendlyApiError(e, fallback) };
};

/**
 * 261015 P4c-2b (D9b) — lỗi `OVERVIEW_NOT_EFFECTIVE` của BẤT KỲ lệnh ghi/AI nào ở ④ (chốt dàn tập, chia / chia lại tập) ⇒ nội dung khối cảnh báo + lối ra "Mở Tổng quan truyện".
 * Lỗi khác ⇒ null (caller giữ đường xử lý cũ).
 */
export const overviewBlockOf = (e: unknown): { text: string; extra: string[] } | null => {
  const code = (e as { response?: { data?: { code?: unknown } } } | null | undefined)?.response?.data?.code;
  if (code !== 'OVERVIEW_NOT_EFFECTIVE') return null;
  const v = overviewErrorView(e, '');
  return { text: v.text, extra: v.extra };
};
